const PowerPointIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 64 64"
    >
      <defs>
        <clipPath id="a">
          <rect x="7" y="4" width="56" height="56" rx="27.73" fill="none" />
        </clipPath>
        <linearGradient
          id="b"
          x1="5.56"
          y1="13.917"
          x2="26.44"
          y2="50.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ca4c28" />
          <stop offset="0.5" stopColor="#c5401e" />
          <stop offset="1" stopColor="#b62f14" />
        </linearGradient>
      </defs>
      <title>PowerPoint_64x</title>
      <g style={{ isolation: 'isolate' }}>
        <path
          d="M34.735,4A27.816,27.816,0,0,0,7,31.734V32l34,4L35,4Z"
          fill="#ed6c47"
        />
        <path
          d="M63,32v-.266A27.816,27.816,0,0,0,35.265,4H35V32l13,6Z"
          fill="#ff8f6b"
        />
        <path d="M63,32A28,28,0,0,1,7,32Z" fill="#d35230" />
        <g clipPath="url(#a)">
          <rect
            width="64"
            height="64"
            fill="none"
            opacity="0.75"
            style={{ mixBlendMode: 'soft-light' }}
          />
        </g>
        <rect width="64" height="64" fill="none" />
        <path
          d="M30.379,16H11.934A27.643,27.643,0,0,0,8,24.39V39.61A27.766,27.766,0,0,0,14.331,51H30.379a2.606,2.606,0,0,0,2.576-2.179A1.976,1.976,0,0,0,33,48.369V18.631A2.621,2.621,0,0,0,30.379,16Z"
          opacity="0.2"
        />
        <path
          d="M30.278,15H12.658A27.7,27.7,0,0,0,8,24.39V39.61A27.714,27.714,0,0,0,13.455,50H30.278a3.685,3.685,0,0,0,2.56-1.05A3.737,3.737,0,0,0,34,46.24V18.76A3.754,3.754,0,0,0,30.278,15Z"
          opacity="0.1"
        />
        <path
          d="M30.379,16H11.934A27.643,27.643,0,0,0,8,24.39V39.61A27.7,27.7,0,0,0,12.658,49H30.379A2.632,2.632,0,0,0,33,46.349v-27.7A2.632,2.632,0,0,0,30.379,16Z"
          opacity="0.2"
        />
        <path
          d="M29.359,16H11.934A27.643,27.643,0,0,0,8,24.39V39.61A27.7,27.7,0,0,0,12.658,49h16.7A2.642,2.642,0,0,0,32,46.349v-27.7A2.642,2.642,0,0,0,29.359,16Z"
          opacity="0.1"
        />
        <rect y="16" width="32" height="32" rx="2.667" fill="url(#b)" />
        <path
          d="M16.241,23.334a6.865,6.865,0,0,1,4.627,1.39,5.031,5.031,0,0,1,1.606,4.025,5.716,5.716,0,0,1-.794,3.009,5.356,5.356,0,0,1-2.258,2.049,7.492,7.492,0,0,1-3.393.731h-3.21v6.129H9.526V23.334Zm-3.422,8.557h2.834a3.618,3.618,0,0,0,2.505-.767,2.874,2.874,0,0,0,.847-2.242q0-2.865-3.246-2.865h-2.94Z"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

export default PowerPointIcon
